import { Viewer, ImagePanorama } from "panolens";
import { useEffect, useRef, useState } from "react";
import "../assets/css/views.css";

const ViewsSkyCrest8 = () => {
    const panoramaRef = useRef(null);
    const viewerRef = useRef(null);

    const [currentImage, setCurrentImage] = useState(3);
    const [mode, setMode] = useState("Day"); // day or night

    const getImagePath = (index, currentMode = mode) => {
        const folder = currentMode === "Day" ? "Day" : "Night";
        console.log("dfldfjishf", folder);
        return `/hdri/Sky_Crest_8/${folder}/${index}.JPG`;
    };

    useEffect(() => {
        if (!panoramaRef.current) return;

        const initialPanorama = new ImagePanorama(getImagePath(currentImage));

        const viewer = new Viewer({
            container: panoramaRef.current,
            autoRotate: false,
            controlBar: false,
            autoRotateSpeed: 1,
        });

        viewer.add(initialPanorama);
        viewerRef.current = viewer;

        return () => {
            viewer.dispose();
        };
    }, []);

    const handleSetHdri = (index) => {
        setCurrentImage(index);
        if (!viewerRef.current) return;

        const newPanorama = new ImagePanorama(getImagePath(index));
        viewerRef.current.add(newPanorama);
        viewerRef.current.setPanorama(newPanorama);
    };

    const handleModeChange = () => {
        const newMode = mode === "Day" ? "Night" : "Day";
        setMode(newMode);

        if (!viewerRef.current) return;

        // Build correct image path based on current floor
        const imagePath =
            currentImage === "Terrace"
                ? `/hdri/Sky_Crest_8/${newMode}/Terrace.JPG`
                : `/hdri/Sky_Crest_8/${newMode}/${currentImage}.JPG`;

        const newPanorama = new ImagePanorama(imagePath);

        viewerRef.current.add(newPanorama);
        viewerRef.current.setPanorama(newPanorama);
    };

    return (
        <div>
            <div
                ref={panoramaRef}
                style={{ width: "100vw", height: "100vh", background: "#000" }}
            />

            {/* Day Night Toggle */}


            <div className="floor_buttons sky_crest_8">
                <div className="day-night-toggle">
                    <label className="switch">
                        <input
                            type="checkbox"
                            checked={mode === "Night"}
                            onChange={handleModeChange}
                        />

                        <span className="slider">
                            <span className="icon sun">☀️</span>
                            <span className="icon moon">🌙</span>
                        </span>
                    </label>
                </div>
                <ul>
                    {[3, 6, 9, 12, 15, 18, 21, 24, 27, 30].map((floor) => (
                        <li key={floor}>
                            <button
                                onClick={() => handleSetHdri(floor)}
                                className={currentImage === floor ? "active" : ""}
                            >
                                {floor}
                            </button>
                        </li>
                    ))}

                    <li>
                        <button
                            onClick={() => handleSetHdri("Terrace")}
                            className={currentImage === "Terrace" ? "active" : ""}
                        >
                            Terrace
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default ViewsSkyCrest8;